import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CrownIcon, XIcon } from 'lucide-react';
const notThis = ['This is not a collection of random exercises copied from the internet.', 'This is not a theory book you have to rewrite before it works in a real class.', 'This is not content designed for a different kind of teacher that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="border-y border-ballet-line bg-white px-4 py-20 sm:py-24" data-id="element-231" data-mp="z25zyylafjr9">
      <div className="mx-auto max-w-4xl text-center" data-id="element-232" data-mp="u3bhjxr8fx7o">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-233" data-mp="u4mlpyolb6zb">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-ballet-gold/60 bg-ballet-goldSoft text-ballet-gold" data-id="element-234" data-mp="2jg6mihhdyqwn">
            <CrownIcon size={25} data-id="element-235" data-mp="2bvz4qfi794a2" />
          </span>
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.15em] text-ballet-rose" data-id="element-236" data-mp="2bv77z1cv90i7">
            The complete professional system
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold leading-tight text-ballet-ink" data-id="element-237" data-mp="2kwn9ejlpdsaa">
            The Most Complete Ballet Teaching Library for Ballet Teachers
            Worldwide
          </h2>
          <h3 className="mt-4 font-display text-3xl font-semibold text-ballet-rose" data-id="element-238" data-mp="1t5r4q69sqty3">
            Ballet Teacher Ready™
          </h3>
          <p className="mx-auto mt-4 max-w-3xl text-base leading-7 text-ballet-muted" data-id="element-239" data-mp="1x7ce3hn4gq3j">
            6 Complete Volumes · 100 Ready-to-Teach Combinations · 5 Strategic
            Bonuses · Everything ready to use from today
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-240" data-mp="19hrv4yqyxsu9">
          <div className="space-y-4 rounded-2xl border border-ballet-line bg-ballet-canvas p-6" data-id="element-241" data-mp="19fe18t80ymoa">
            {notThis.map(item => <div key={item} className="flex gap-3 text-sm leading-6 text-ballet-muted" data-id="element-242" data-mp="2hqpebsouj29m">
                <XIcon size={18} className="mt-0.5 shrink-0 text-ballet-rose" data-id="element-243" data-mp="2crmecmnq3m8i" />
                {item}
              </div>)}
          </div>
          <div className="rounded-2xl border border-ballet-gold/60 bg-ballet-goldSoft/50 p-6" data-id="element-244" data-mp="2mhfg6vy2cmzk">
            <div className="flex gap-3 text-base font-medium leading-7 text-ballet-ink" data-id="element-245" data-mp="1ys37ryak8iyb">
              <CheckIcon size={20} className="mt-1 shrink-0 text-ballet-gold" data-id="element-246" data-mp="1tt9xsfuhfa2w" />
              This is a complete professional teaching library—so you walk into
              every class completely prepared, confident, and ready to deliver a
              session your students will feel.
            </div>
          </div>
        </div>
      </div>
    </section>;
}